<template>
  <div>
    <b-modal
      v-model="subjectModal"
      size="xl"
      scrollable

      ok-only
      header-class="border-bottom-0"
    >
      <SubjectHistoryForms :forms="forms" />
    </b-modal>
  </div>
</template>

<script>

import { HTTP } from "@/utilities/http-common";

import { mapState } from "vuex";

import * as _ from 'lodash';

export default {
  components: {

  },
  data: function() {
    return {
      forms: []
    }
  },
  computed: {
    ...mapState("dialog", ["modalSubjectId"]),
    subjectModal: {
      get: function() {
        return this.$store.state.dialog.subjectModal;
      },
      set: function() {
        this.$store.dispatch("dialog/toggleSubjectModal");
      },
    },
  },
  watch: {
    modalSubjectId: function(newVal) {
      if (newVal) {
        this.subjectId = newVal;
        this.search();
      }
    },
  },
  methods: {
    search: function() {
      const that = this;
      HTTP.get("/kenya/subject/forms?subject_id=" + that.subjectId).then(
        (response) => {
          let forms = [];
          _.each(response.data, function(def) {
            _.each(def.items, function(form) {
              forms.push({
                name: def.name,
                data: form,
              });
            });
          });

          that.forms = _.orderBy(forms, ["data.received_on"], ["asc"]);
        }
      ).catch((error) => {
        this.$store.dispatch("dialog/toggleSubjectModal");
        this.$bvModal.msgBoxOk('Subject with ID not found.', {
          title: 'Subject Error',
          okVariant: 'success',
          centered: true
        })
          .then(value => {

          })
          .catch(err => {
            // An error occurred
          })
      });
    },
  },
};
</script>
